"use client";

import type { FC } from "react";

import { useRouter } from "next/navigation";

import { SearchBox as SearchBoxUI } from "@jti/ui/components/Search";

import type { searchBoxInputs } from "./SearchBox.builder";
import { DEFAULT_MIN_SEARCH_TEXT_LENGTH } from "./SearchBox.builder";

export type SearchBoxProps = BuilderComponentProps<typeof searchBoxInputs>;

export const SearchBox: FC<SearchBoxProps> = ({ resultsPage, translations, minSearchTextLength }) => {
  const { push } = useRouter();

  return (
    <SearchBoxUI
      resultsPage={resultsPage}
      translations={translations}
      minSearchTextLength={minSearchTextLength ?? DEFAULT_MIN_SEARCH_TEXT_LENGTH}
      navigationFn={(url: string) => push(url)}
    />
  );
};
